import {ReportFilterBase} from './reportFilterBase';

export class ReportFilterByDeviceName extends ReportFilterBase {

    deviceName = 'Filter By Device';

}
